"use client";
import { jsx as i } from "react/jsx-runtime";
import { cn as l } from "../../../utils/cn.js";
import { setComponentColor as n } from "../../../utils/setComponentColor.js";
import { stylesCard as t } from "./styles.js";
const p = ({
  color: e = "card",
  size: o = "lg",
  wideSticky: r,
  className: m,
  children: s,
  ...a
}) => /* @__PURE__ */ i(
  "div",
  {
    className: l(
      t.base,
      t.size[o],
      r && t.wideSticky[o],
      m
    ),
    style: n(e),
    ...a,
    children: s
  }
);
p.displayName = "PlateContent";
export {
  p as PlateContent
};
